import React from 'react';
import LogInForm from './components/LogInForm';
import Logo from '../../shared/components/icons/logoOriginal';

const LogIn = () => (
  <div className="account">
    <div className="account__wrapper">
      <div className="account__card">
        <div className="account__head">
          <Logo />
          <h3 className="account__title">Warehouse Login</h3>
        </div>
        <LogInForm />
      </div>
    </div>
  </div>
);

export default LogIn;

// if you want to add select, date-picker and time-picker in your app you need to uncomment the first
// four lines in /scss/components/form.scss to add styles
